import Auth from '../../modules/Authentication'
import { apiUrl } from '../../variables/index'
import { handleErrors, handleResponse } from '../../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Clients {
  auth = new Auth()
  create = (member) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}clients/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(member),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  list = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}clients/`, { headers }).then(handleErrors).then(handleResponse)
  }
  get = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}clients/${key}`, { headers }).then(handleErrors)
  }
  remove = (data) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}clients/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  getMember = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}clients/${key}/member`, { headers }).then(handleErrors).then(handleResponse)
  }
  update = (data) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}clients/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
  permissions = {
    list: (key, org) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/${key}/permissions/${org}`, {
        headers,
      }).then(handleErrors)
    },
    update: (key, org, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/${key}/permissions/${org}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  }
  banks = {
    list: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/${key}/banks/`, { headers }).then(handleErrors).then(handleResponse)
    },
    update: (key, bankID, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/${key}/banks/${bankID}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  contracts = {
    list: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/${key}/contracts/`, { headers }).then(handleErrors).then(handleResponse)
    },
  }
  requisitions = {
    list: () => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clientreqs/`, { headers }).then(handleErrors).then(handleResponse)
    },
  }
  files = {
    list: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/${key}/files/`, { headers }).then(handleErrors).then(handleResponse)
    },
    update: (key, bankID, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/${key}/banks/${bankID}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  registrations = {
    list: () => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/registrations/`, { headers }).then(handleErrors).then(handleResponse)
    },
    get: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/registrations/${key}`, { headers }).then(handleErrors).then(handleResponse)
    },
    approve: (data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/registrations/approve`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    update: (data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}/clients/registrations/`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    remove: (data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}clients/registrations/delete`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    create: (data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}/clients/registrations/`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  }
}
